/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed } from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed';
import {
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSONTyped,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSON,
    IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSONTyped,
} from './IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed';

/**
 * 
 * @export
 * @interface IntegrationEventPccPatientLeadsInnerOccupanciesInner
 */
export interface IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    /**
     * 
     */
    occupancy_type?: string;
    /**
     * 
     */
    bed?: IntegrationEventPccPatientLeadsInnerOccupanciesInnerBed;
}

/**
 * Check if a given object implements the IntegrationEventPccPatientLeadsInnerOccupanciesInner interface.
 */
export function instanceOfIntegrationEventPccPatientLeadsInnerOccupanciesInner(value: object): value is IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    return true;
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'occupancy_type': json['occupancy_type'] == null ? undefined : json['occupancy_type'],
        'bed': json['bed'] == null ? undefined : IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedFromJSON(json['bed']),
    };
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSON(json: any): IntegrationEventPccPatientLeadsInnerOccupanciesInner {
    return IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSONTyped(json, false);
}

export function IntegrationEventPccPatientLeadsInnerOccupanciesInnerToJSONTyped(value?: IntegrationEventPccPatientLeadsInnerOccupanciesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occupancy_type': value['occupancy_type'],
        'bed': IntegrationEventPccPatientLeadsInnerOccupanciesInnerBedToJSON(value['bed']),
    };
}

